import { reloadPageOnChunkFailure } from "./reloadPage";

let listenerRegistered = false;

/**
 * The safety net. Vite fires "vite:preloadError" whenever any chunk fails to
 * load — even ones we don't wrap in our own `catch` (React.lazy, CSS). Call
 * this once at startup so those still trigger a reload. Safe to call twice.
 *
 * @see https://vite.dev/guide/build#load-error-handling
 */
export const registerChunkErrorReload = (): void => {
  if (listenerRegistered || typeof window === "undefined") return;
  listenerRegistered = true;

  window.addEventListener("vite:preloadError", (event) => {
    // Only stop Vite's default handler when we actually reload (so it doesn't
    // double-report to Sentry mid-reload). If the guard blocked the reload
    // (already tried, still broken), let Vite's default run so the real error
    // still reaches Sentry instead of being silently swallowed.
    if (reloadPageOnChunkFailure()) {
      event.preventDefault();
    }
  });
};
